export default __webpack_public_path__ + "static/media/etransactLogo.13b9ff8f.png";